'use client'

import { useEffect, useRef } from 'react'

export const SanityCodeBlockContent = ({ htmlContent }: { htmlContent: string | TrustedHTML }) => {
  const containerRef = useRef<HTMLDivElement | null>(null)

  // In order to execute external scripts included in the HTML content, we need to replace them with new script elements.
  useEffect(() => {
    if (!containerRef.current) {
      return
    }

    const scripts = containerRef.current.querySelectorAll('script')

    scripts.forEach((oldScript) => {
      const newScript = document.createElement('script')

      Array.from(oldScript.attributes).forEach((attr) => {
        newScript.setAttribute(attr.name, attr.value)
      })

      newScript.appendChild(document.createTextNode(oldScript.innerHTML))

      oldScript.parentNode?.replaceChild(newScript, oldScript)
    })
  }, [htmlContent]) // Re-run whenever Sanity data changes

  return <div ref={containerRef} dangerouslySetInnerHTML={{ __html: htmlContent }} />
}
